import setupInterceptors from '@/services/setupInterceptors';
import axios from 'axios';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['attributes']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8000')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
export default {
  getCompanyAbrevs: function getCompanyAbrevs() {
    return appApisGTW.get('/api/v1/attribute-management/tables/itc-company/itc-company-abrev').then(function (response) {
      return response.data;
    });
  },
  getLabelCatalog: function getLabelCatalog() {
    return appApisGTW.get('/api/v1/attribute-management/tables/label-catalog').then(function (response) {
      return response.data;
    });
  },
  getStatusLogTypes: function getStatusLogTypes() {
    return appApisGTW.get('/api/v1/attribute-management/catalogs/status-logtype').then(function (response) {
      return response.data;
    });
  },
  getAttributeSourcesCatalog: function getAttributeSourcesCatalog() {
    return appApisGTW.get('/api/v1/attribute-management/catalogs/attribute-source').then(function (response) {
      return response.data;
    });
  },
  getSolicitudeTypes: function getSolicitudeTypes() {
    return appApisGTW.get('/api/v1/attribute-management/catalogs/solicitude-type').then(function (response) {
      return response.data;
    });
  },
  getBusinessUserServiceAccounts: function getBusinessUserServiceAccounts(companyCode) {
    return appApisGTW.get("/api/v1/attribute-management/catalogs/business-user/companies/".concat(companyCode)).then(function (response) {
      return response.data;
    });
  }
};